/* eslint-disable */
import React from "react"

import { Box, Chip, Fade, IconButton, Stack, Typography } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import CheckIcon from "@mui/icons-material/Check"

import useAudioContext from "../../utils/eSteth/AudioState"
import { LoadingButton } from "@mui/lab"

const DeviceInfo = () => {
	const { device, getAudio, closeDevice, loading, createAudio } = useAudioContext()

	const getAudioHandler = async () => {
		await getAudio(device.device)
	}

	const createAudioHandler = async () => {
		await createAudio()
	}

	const closeDeviceHandler = () => {
		closeDevice()
	}

	if (!device) return <></>
	return (
		<Fade in={Boolean(device)}>
			<Box sx={{ width: "full", padding: "1rem", border: "1px solid black", borderRadius: "0.5rem" }}>
				<Stack spacing={2}>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "full",
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Typography variant="subtitle1">{`Device ID: ${device.device}`}</Typography>
						<IconButton color="default" onClick={closeDeviceHandler}>
							<CloseIcon />
						</IconButton>
					</Stack>
					<Stack direction="row" spacing={1}>
						<Chip variant="filled" size="medium" label="raw" color="primary" icon={<CheckIcon />} />
						<Chip
							variant="filled"
							size="medium"
							label="wav"
							color={device.wav ? "success" : "error"}
							icon={device.wav ? <CheckIcon /> : <CloseIcon />}
						/>
					</Stack>
					<Stack direction="row" spacing={2}>
						{Boolean(device.wav) && (
							<LoadingButton
								variant="contained"
								color="success"
								loading={loading.waveform}
								onClick={getAudioHandler}
							>
								Get Waveform
							</LoadingButton>
						)}
						{Boolean(device.raw) && (
							<LoadingButton
								variant="contained"
								color="primary"
								loading={loading.convert}
								onClick={createAudioHandler}
							>
								Convert raw to wav
							</LoadingButton>
						)}
					</Stack>
				</Stack>
			</Box>
		</Fade>
	)
}

export default DeviceInfo

